'use strict';
/**
 * a method for Date, translate timestamp into a date format;
 * such as: require('timestamp-format')('yyyy-MM-dd hh:mm:ss.S',new Date().getTime()) => 2016-08-22 12:30:55.5
 * 
 * Code by https://github.com/mumuy/tools-library/blob/gh-pages/code/Tool.js
 * Autor : mumuy(@passer-by)
 * 
 * @param {String} `fmt`:a date template
 * @param {Number} `timestamp`:timestamp
 * @return {String} a format date
 *      
 */
module.exports = function(fmt, timestamp) {
    if (!timestamp) {
        timestamp = new Date().getTime();
    }
    if (typeof fmt !== 'string'){
        return console.warn('[timestamp-format]:the @parma `fmt` is not a String!第一个参数fmt必须是字符串！')
    };
    var day = new Date(timestamp);
    var o = {
        "M+": day.getMonth() + 1, //月份 
        "d+": day.getDate(), //日 
        "h+": day.getHours(), //小时 
        "m+": day.getMinutes(), //分 
        "s+": day.getSeconds(), //秒 
        "q+": Math.floor((day.getMonth() + 3) / 3), //季度 
        "S": day.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (day.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/timestamp-format/index.js
// module id = NWFj
// module chunks = 69